export const SOURCE_1CUU = '1cuu';
export const SOURCE_CB = 'cb';
